<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <form class="form-div">
    <p class="heading">What is your gender?</p>
    <div class="gender-container">
      <mat-radio-group [formControl]="genderControl" class="gender-radio-group" required>
        @for (option of genderOptions; track $index) {
          <mat-radio-button
            class="gender-option"
            [value]="option.value"
          >
            {{ option.label }}
          </mat-radio-button>
        }
        
        <mat-radio-button
          class="gender-option self-describe-option"
          value="self-describe"
        >
          <div class="self-describe-container">
            <label for="selfDescribeInput">Prefer to self describe</label>
            <input
              id="selfDescribeInput"
              matInput
              [formControl]="selfDescribeText"
              (focus)="selectSelfDescribe()"
              maxlength="200"
            />
          </div>
        </mat-radio-button>
      </mat-radio-group>

      @if (genderControl.hasError('required') && (
        genderControl.touched || genderControl.dirty)
      ) {
        <mat-error class="input-error">
          This question is required.
        </mat-error>
      }

      @if (selfDescribeText.invalid) {
        @if (selfDescribeText.hasError('required')) {
          <mat-error class="input-error">
            Please describe your gender
          </mat-error>
        }
        @if (selfDescribeText.hasError('minlength')) {
          <mat-error class="input-error">
            Minimum 3 characters required
          </mat-error>
        }
        @if (selfDescribeText.hasError('maxlength')) {
          <mat-error class="input-error">
            Maximum 200 characters allowed
          </mat-error>
        }
      }
    </div>

    <app-biq-button (buttonEmitter)="onClickContinue()"></app-biq-button>
  </form>
</div>